import React from 'react';

import axios from 'axios';
import { Button, Form, Loader } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class ExamRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            course: null,
            exam: null,

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.registrationExam = this.registrationExam.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.ungradedCourseImplementations !== prevProps.ungradedCourseImplementations) {
            this.resetForm();
        }
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        }, () => {
            if (name === 'course') { this.props.fetchExamOptionsByCourseImplementation(value.courseImplementationId);  }

        });
    }

    registrationExam() {
        if (!this.state.course || !this.state.exam) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.course) { this.setState({ course: true }); } else { this.setState({ course: false }); }
            if (!this.state.exam) { this.setState({ exam: true }); } else { this.setState({ exam: false }); }
        } else {
            this.setState({ loader: true });
            let obj = {
                gradedActivityId: this.state.exam,
                studentCourseImplementationId: this.state.course.studentCourseImplementationId
            };


            axios.post('/student-exams/registration/', { ...obj })
                .then(res => {
                    this.setState({ loader: false });

                    this.resetForm();
                    toast('Uspješno ste prijavili ispit!');
                });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.semester !== prevProps.semester) {
            this.resetForm();
        }
    }

    resetForm() {
        this.setState({

            courseImplementation: null,
            exam: null,
            course: null

        });
    }


    render() {
        return (
            <div>
                <Loader active={this.state.loader} />

                <Form>

                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.courseErr}>
                            <label>Predmet </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir predmeta"
                                value={this.state.course}
                                onChange={this.handleInputChange}
                                name="course"
                                options={this.props.ungradedCourseImplementations}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.examErr}>
                            <label>Ispit</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Ispit"
                                value={this.state.exam}
                                onChange={this.handleInputChange}
                                name="exam"
                                // disabled={!this.state.courseImplementation}
                                options={this.props.examOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button
                        floated="right"
                        color="blue"
                        onClick={this.registrationExam}
                    >Prijavi ispit </Button>
                    <br />
                    <br />
                </Form>

                <ToastContainer hideProgressBar />


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Students/ExamRegistration/ExamRegistration.js